var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useContext, useState } from 'react';
import { ZdsAccordion, ZdsIcon, ZdsItem } from '@zig-design-system/ui-components-react';
import ApiService from '../services/ApiService';
import { RootContext } from '../../Context/RootContext';
import Scroll from '../../Shared/Utility/Scroll';
const SubnodeContent = ({ subnode, asLink, level = 0 }) => {
    var _a;
    const [contentNode, setContentNode] = useState(null);
    const rootContext = useContext(RootContext);
    const apiService = new ApiService(rootContext);
    const subnodeContent = (subnode) => {
        const getSubnodeContent = () => __awaiter(void 0, void 0, void 0, function* () {
            const contentNode = yield apiService.getNode(subnode.uid);
            setContentNode(contentNode);
        });
        if (contentNode === null) {
            getSubnodeContent();
        }
    };
    if (asLink) {
        const link = subnode.externalLink || '#/node/' + subnode.uid;
        const icon = subnode.externalLink ? 'open_in_new' : 'navigate_next';
        const linkTarget = subnode.externalLink ? '_blank' : '_self';
        return (React.createElement(ZdsItem, { onZdsClick: () => Scroll.to(0, 0), link: link, linkTarget: linkTarget },
            React.createElement("div", { slot: "primary-text", className: "zds-bold" }, subnode.title),
            React.createElement("div", { slot: "content-end" },
                React.createElement(ZdsIcon, { name: icon, size: "lg" }))));
    }
    if (subnode.externalLink) {
        return (React.createElement(ZdsAccordion, { link: subnode.externalLink },
            React.createElement("div", { slot: "header" }, subnode.title),
            React.createElement("div", { slot: "body" })));
    }
    return (React.createElement(ZdsAccordion, { "icon-name": "plus", onZdsAccordionOpen: () => subnodeContent(subnode) },
        React.createElement("div", { slot: "header" }, subnode.title),
        React.createElement("div", { slot: "body" },
            (contentNode === null || contentNode === void 0 ? void 0 : contentNode.content[0].html) && (React.createElement("div", { dangerouslySetInnerHTML: { __html: contentNode.content[0].html } })),
            React.createElement("div", { className: level === 0 && 'zds-padding-left-6' }, (_a = contentNode === null || contentNode === void 0 ? void 0 : contentNode.subnodes) === null || _a === void 0 ? void 0 : _a.map((child) => {
                if (level === 0)
                    return React.createElement(SubnodeContent, { subnode: child, asLink: asLink, level: level + 1 });
                return (React.createElement(ZdsAccordion, { link: rootContext.pluginContext.detailPageUrl +
                        '?node=' +
                        child.uid +
                        '/#/node/' +
                        child.uid, key: contentNode.uid + '-' + child.uid },
                    React.createElement("div", { slot: "header", className: "zds-bold zds-truncate" }, child.title)));
            })))));
};
export default SubnodeContent;
